// src/pages/ServicesOverview.js
import React from 'react';
import CTASection from '../components/CTASection';

function ServicesOverview() {
  return (
    <div className="services-page">
      <h1>Our Services</h1>
      <section className="services-list">
        <div className="service-item">
          <h3>Translation Services</h3>
          <p>
            We provide accurate and culturally sensitive translations across multiple languages, ensuring your message retains its original intent and tone. Our team of certified linguists ensures clarity and precision in every word, tailored to your industry and audience.
          </p>
        </div>
        <div className="service-item">
          <h3>Localization Services</h3>
          <p>
            Our localization services adapt your content to specific markets, considering regional language nuances, cultural preferences, and local standards. We help brands connect with global audiences by delivering context-aware, region-specific adaptations of your content.
          </p>
        </div>
        <div className="service-item">
          <h3>DTP Services</h3>
          <p>
            We offer multilingual desktop publishing services to format and design documents for print and digital use, maintaining linguistic and visual integrity. Our DTP experts ensure seamless formatting across all languages and layouts, from brochures to manuals.
          </p>
        </div>
        <div className="service-item">
          <h3>Proofreading Services</h3>
          <p>
            Our expert linguists proofread thoroughly to ensure your content is grammatically correct, stylistically polished, and ready for publication. We fine-tune every sentence to match your tone, style, and purpose while eliminating all linguistic errors.
          </p>
        </div>
        <div className="service-item">
          <h3>Document Translations</h3>
          <p>
            We specialize in translating legal, medical, technical, and business documents with the utmost accuracy and confidentiality. Each document undergoes a strict quality assurance process to meet global compliance and industry standards.
          </p>
        </div>
        <div className="service-item">
          <h3>Voice Over Services</h3>
          <p>
            We deliver professional voice-over recordings in multiple languages and neutral accents tailored to suit eLearning, commercials, and multimedia projects. Our voice artists provide authentic delivery that aligns perfectly with your message and target audience.
          </p>
        </div>
      </section>

      <CTASection />
    </div>
  );
}

export default ServicesOverview;